export function convertDataFromBytes(sizeInBytes: number) {
  var unitsValue = ["B", "KB", "MB", "GB", "TB"];
  // if (sizeInBytes === 0) {
  //     sizeInBytes = 0;
  //     return sizeInBytes + unitsValue[0];
  // } else {
  //     var i: any = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
  //     var decs: any = unitsValue[i] === 'GB' ? 1 : 0;
  //     let size: any = sizeInBytes / Math.pow(1024, i);
  //     let sizeInBytes1: any = size.toFixed(decs) * 1;
  //     return sizeInBytes1 + unitsValue[i];
  // }
  if (sizeInBytes > 0) {
    var i: any = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
    var decs: any = unitsValue[i] === "GB" ? 2 : 0;
    let size: any = sizeInBytes / Math.pow(1024, i);
    let sizeInBytes1: any = size.toFixed(decs) * 1;
    return sizeInBytes1 + unitsValue[i];
  } else {
    sizeInBytes = 0;
    return sizeInBytes + unitsValue[0];
  }
}

export function convertDataFromBytesWithSpace(sizeInBytes: number) {
  var unitsValue = [" B", " KB", " MB", " GB", " TB"];

  if (sizeInBytes > 0) {
    var i: any = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
    var decs: any = unitsValue[i] === "GB" ? 1 : 0;
    let size: any = sizeInBytes / Math.pow(1024, i);
    let sizeInBytes1: any = size.toFixed(decs) * 1;
    return sizeInBytes1 + unitsValue[i];
  } else {
    sizeInBytes = 0;
    return sizeInBytes + unitsValue[0];
  }
}

export function getMBorGBFromBytes(bytes: number): any {
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 KB";
  let i = Math.floor(Math.log(bytes) / Math.log(1024));
  if (i === 0) return bytes + " " + sizes[i];
  return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
}
